import axios from "axios"
import store from "@/store"
import router from "@/router/index";
import {Message} from 'element-ui';


axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT

axios.defaults.timeout = 8000

axios.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// 请求拦截器
axios.interceptors.request.use(request =>{
    if (localStorage.getItem("token")){
        request.headers.token = localStorage.getItem("token")
    }
    return request;
})

// 响应拦截器
axios.interceptors.response.use(response => {
    return response;
},error => {
    Message.error("通讯异常，请稍后重试！");
    return Promise.reject(error);
})

export default axios;